import {ShapeCommand} from '../commands.template';
import {v4 as uuidv4} from 'uuid';

export class ResourceMoveCommand extends ShapeCommand {
  protected services: any;

  id = uuidv4();

  constructor(data) {
    super(data);
  }

  public execute() {
    super.execute();
    const model = this.services.editorRegistrySvc.getGraph().getModel();

    const srcCell = model.getCell(this.object.srcMxKey);

    srcCell.skipUndo = true;
    const tgtCell = model.getCell(this.object.tgtMxKey);

    tgtCell.skipUndo = true;

    const cells = [srcCell, tgtCell];

    return this.services.resourceSvc.move({
      cells,
      resource: this.object.resource,
      position: this.object.position,
      deltaKey: this.id
    });
  }

  public reverse() {
    super.reverse();
    const model = this.services.editorRegistrySvc.getGraph().getModel();

    const srcCell = model.getCell(this.object.tgtMxKey);

    srcCell.skipUndo = true;
    const tgtCell = model.getCell(this.object.srcMxKey);

    tgtCell.skipUndo = true;

    const cells = [srcCell, tgtCell];

    return this.services.resourceSvc.move({
      cells,
      resource: this.object.resource,
      position: this.object.oldPosition,
      deltaKey: this.id
    });
  }
}
